import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-grey mb-4" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-4 w-1/2 mb-5" }
const _hoisted_3 = { class: "inputTitle" }
const _hoisted_4 = { class: "inputField flex-grow" }
const _hoisted_5 = { class: "inputTitle" }
const _hoisted_6 = { class: "inputField flex-grow" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = { class: "text-center" }

import {onMounted, ref} from "vue";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import Error from "@/components/Error.vue";
import {ErrorLocationType} from "@/utilities/enums/Enums";
import {useGlobalStore} from "@/stores/GlobalStore";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {$t} from "@/utilities/i18n/config";
import {SettingService} from "@/utilities/services/entities/SettingService";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProviderSettingsTab',
  setup(__props) {

const currentSettings = ref({dmaPersistence:0,expiredText:""});
const globalStore = useGlobalStore();

const settingService = new SettingService();

const saveProviderSettings = async ()=>{
  const updatePersistanceResp = await settingService.postUpdateDmaPersistance(currentSettings.value.dmaPersistence);
  if(updatePersistanceResp === null || updatePersistanceResp === undefined || updatePersistanceResp.statusCode !== 0){
    ErrorHandler.handleError(updatePersistanceResp, ErrorLocationType.table);
    return;
  }

  const updateExpiredTextResp = await settingService.postUpdateExpiredText(currentSettings.value.expiredText);
  if(updateExpiredTextResp === null || updateExpiredTextResp === undefined || updateExpiredTextResp.statusCode !== 0){
    ErrorHandler.handleError(updateExpiredTextResp, ErrorLocationType.table);
    return;
  }

  globalStore.showSuccess($t("global.saved"));
}

const setData = async ()=>{
  globalStore.gridDataIsLoading = true;
  const providerSettingsResponse = await settingService.getCompanySettings();
  if(providerSettingsResponse === null || providerSettingsResponse === undefined || providerSettingsResponse.statusCode !== 0){
    ErrorHandler.handleError(providerSettingsResponse, ErrorLocationType.table);
    return;
  }

  currentSettings.value.dmaPersistence = +providerSettingsResponse.dmaPersistence;
  currentSettings.value.expiredText = providerSettingsResponse.expiredText;

  globalStore.gridDataIsLoading = false;
}

onMounted(async ()=>{
  await setData();
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(Error, {
        errorLoc: _unref(ErrorLocationType).table
      }, null, 8, ["errorLoc"]),
      _createElementVNode("div", null, [
        _createElementVNode("h4", _hoisted_1, _toDisplayString(_unref($t)('settings.providerSettings.inactiveUsers')), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref($t)('settings.providerSettings.elapseTime')), 1),
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                min: "0",
                max: "30",
                class: "w-full",
                type: "number",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentSettings.value.dmaPersistence) = $event))
              }, null, 512), [
                [_vModelText, currentSettings.value.dmaPersistence]
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref($t)('settings.providerSettings.infoText')), 1),
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("textarea", {
                class: "w-full",
                rows: "5",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentSettings.value.expiredText) = $event))
              }, null, 512), [
                [_vModelText, currentSettings.value.expiredText]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              class: "primary ml-auto",
              onClick: saveProviderSettings
            }, _toDisplayString(_unref($t)('global.save')), 1)
          ])
        ])
      ])
    ], 512), [
      [_vShow, !_unref(globalStore).gridDataIsLoading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_8, [
      _createVNode(LoadingSpinner)
    ], 512), [
      [_vShow, _unref(globalStore).gridDataIsLoading]
    ])
  ], 64))
}
}

})